var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "emd-container" }, [
      _c(
        "div",
        { staticClass: "emd-container__header eu-py_4_md eu-px_5_md" },
        [
          _c("h2", { staticClass: "emd-text _size_section _color_default" }, [
            _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
          ]),
        ]
      ),
      _c("hr", { staticClass: "emd-divider" }),
      _c(
        "div",
        { staticClass: "emd-container__content eu-pa_5_md" },
        [
          _vm.tabbarError.status
            ? _c("emd-alert", {
                attrs: {
                  variant: "danger",
                  title: _vm.$t("tabbarError"),
                  autoclose: "",
                },
                on: {
                  cancel: function ($event) {
                    _vm.tabbarError.status = false
                  },
                },
              })
            : _vm._e(),
          _c("form", { attrs: { action: "" } }, [
            _c("div", { staticClass: "eu-flex eu-column eu-row_md" }, [
              _c("div", { staticClass: "eu-flex-item eu-basis_4_md" }, [
                _c("div", { staticClass: "emd-form-group" }, [
                  _c("label", { staticClass: "emd-label _required" }, [
                    _vm._v(_vm._s(_vm.$t("dueDate"))),
                  ]),
                  _c("div", { staticClass: "emd-input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "##/##/####",
                          expression: "'##/##/####'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.boleto.due_at,
                          expression: "boleto.due_at",
                        },
                      ],
                      staticClass: "emd-input",
                      class: {
                        _state_error:
                          _vm.$v.boleto.due_at.$invalid &&
                          _vm.showFeedbacks.status,
                      },
                      attrs: { type: "text", placeholder: "dd/mm/aaaa" },
                      domProps: { value: _vm.boleto.due_at },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.boleto, "due_at", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm.$v.boleto.due_at.$invalid &&
                  _vm.showFeedbacks.status &&
                  !_vm.boleto.due_at.length
                    ? _c(
                        "p",
                        { staticClass: "emd-input-feedback _state_error" },
                        [_vm._v(_vm._s(_vm.$t("hint.required")))]
                      )
                    : _vm._e(),
                  _vm.$v.boleto.due_at.$invalid &&
                  _vm.showFeedbacks.status &&
                  _vm.boleto.due_at.length
                    ? _c(
                        "p",
                        { staticClass: "emd-input-feedback _state_error" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("hint.dueDate", {
                                date: _vm.setDatePlaceHolder,
                              })
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "eu-flex-item eu-basis_12" }, [
                _c("div", { staticClass: "emd-form-group" }, [
                  _c("label", { staticClass: "emd-label" }, [
                    _vm._v(_vm._s(_vm.$t("instructions"))),
                  ]),
                  _c("div", { staticClass: "emd-input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.boleto.instructions,
                          expression: "boleto.instructions",
                        },
                      ],
                      staticClass: "emd-input",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("instructionsPlaceholder"),
                      },
                      domProps: { value: _vm.boleto.instructions },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.boleto,
                            "instructions",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "el-chunk eu-mt_4" }, [
                _c("label", { staticClass: "emd-label _required" }, [
                  _vm._v(_vm._s(_vm.$t("address.title"))),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "emd-form-box _border_base eu-basis_12_md",
                  class: { _active: true },
                },
                [
                  _vm.shouldShowCheckBox
                    ? _c("div", { staticClass: "emd-form-box__content" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-checkbox",
                            attrs: { for: "useclientaddress" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.billingAddress.use_client_address,
                                  expression:
                                    "billingAddress.use_client_address",
                                },
                              ],
                              staticClass: "emd-checkbox__input",
                              attrs: {
                                name: "useclientaddress",
                                type: "checkbox",
                                id: "useclientaddress",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.billingAddress.use_client_address
                                )
                                  ? _vm._i(
                                      _vm.billingAddress.use_client_address,
                                      null
                                    ) > -1
                                  : _vm.billingAddress.use_client_address,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.billingAddress.use_client_address,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.billingAddress,
                                          "use_client_address",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.billingAddress,
                                          "use_client_address",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.billingAddress,
                                      "use_client_address",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-checkbox__area" }),
                            _c("span", { staticClass: "eu-ml_2" }, [
                              _vm._v(_vm._s(_vm.$t("address.checkbox"))),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "emd-form-box__content" },
                    [
                      _vm.shouldBeOpenAddressCard
                        ? _c("address-card")
                        : _c("address-form", {
                            attrs: {
                              address: _vm.billingAddress,
                              required: true,
                            },
                            on: { toggle: _vm.toggleAddressFormState },
                          }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "el-section" }, [
      _c(
        "div",
        {
          staticClass:
            "eu-display_flex eu-justify_space-between eu-wrap_reverse",
        },
        [
          _c(
            "button",
            {
              staticClass: "emd-btn _color_secondary _type_text _block_mobile",
              on: { click: _vm.reverseRoute },
            },
            [
              _c("i", { staticClass: "uil uil-angle-left" }),
              _vm._v(" " + _vm._s(_vm.$t("customer")) + " "),
            ]
          ),
          _c(
            "button",
            {
              staticClass:
                "emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm",
              on: { click: _vm.nextRoute },
            },
            [
              _vm._v(" " + _vm._s(_vm.$t("review")) + " "),
              _c("i", { staticClass: "uil uil-angle-right" }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }